import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable max-statements */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getInfo } from './getInfo';

/**
 * translateToReactServerDOM will convert props to strings for ReactDOMServer.toString
 * to create a markup script element
 * @param {*} props the react props object
 * @returns {string} can be embedded into a script block for ReactDOMServer.toString
 */
export function translateToReactServerDOM(props) {
  var serializedProps = [];
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (typeof value === 'string') {
      serializedProps.push("".concat(key, ": '").concat(value, "'"));
    } else if (typeof value === 'function') {
      serializedProps.push("".concat(key, ": function(payload) {\n        if (window[props.nameSpace][props.id].").concat(key, ") {\n          return window[props.nameSpace][props.id].").concat(key, "(payload);\n        }\n        window[props.nameSpace][props.id].delayed.").concat(key, " = { payload };\n      }"));
    }
  });
  return "const props = { ".concat(serializedProps.join(', '), " }");
}

/**
 * translateFromReactServerDOM will iterate props and look for queued action results that
 * are available on the client already. It will also wire the static prop functions
 * to the real functions so we only need to iterate once
 * @param {*} props the React props
 * @param {*} container the object add the delegate methods to
 */
export function translateFromReactServerDOM(props, container) {
  Object.entries(props).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    if (typeof value === 'function') {
      if (container.delayed[key]) {
        value(container.delayed[key].payload);
        delete container.delayed[key];
      }
      container[key] = value;
    }
  });
}
function ServerDOMLoader(props) {
  var id = props.id,
    nameSpace = props.nameSpace,
    onPrefetch = props.onPrefetch,
    loadingSpinner = props.loadingSpinner;
  useEffect(function () {
    onPrefetch === null || onPrefetch === void 0 ? void 0 : onPrefetch();
    window[nameSpace] = window[nameSpace] || {};
    window[nameSpace][id] = window[nameSpace][id] || {
      delayed: {}
    };
    var container = window[nameSpace][id];
    translateFromReactServerDOM(props, container);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, loadingSpinner, /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n      (function(){\n        ".concat(translateToReactServerDOM(props), "\n\n        window[props.nameSpace] = window[props.nameSpace] || {};\n        window[props.nameSpace][props.id] = window[props.nameSpace][props.id] || { delayed: {} };\n\n        (").concat(getInfo.toString(), ")(props);\n      })();")
    }
  }));
}
export default ServerDOMLoader;
ServerDOMLoader.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  entryKey: PropTypes.string.isRequired,
  nameSpace: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired,
  replaceSrcMethodName: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onPrefetch: PropTypes.func,
  onAssetsLoad: PropTypes.func,
  loadingSpinner: PropTypes.func
};
//# sourceMappingURL=ServerDOMLoader.js.map